import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef, useEffect } from "react";
export var isBrowser = function isBrowser() {
  return true;
};
export var getParameterValue = function getParameterValue(name) {
  var url = window.location.href;
  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);

  if (results && parseInt(results[2], 10) > 0) {
    return parseInt(results[2], 10);
  }
};
export var useDebounce = function useDebounce(value, delay) {
  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};
export var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};
export var useScript = function useScript(url) {
  useEffect(function () {
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [url]);
};
export var getHost = function getHost(host) {
  if (host !== null && host !== void 0 && host.includes("localhost")) {
    return "videosync.localhost";
  } else if (host !== null && host !== void 0 && host.includes("vsync")) {
    return "vsync.co";
  }

  return "videosync.fi";
};